import {exeRequest} from '../utils/APIUtils'

export default {
 get : async  () => exeRequest("/clients/me/concessionnaires", "GET"),
 verify:async  (data) => exeRequest("/clients/checking-data", "POST", data),
 register: async (data)=> exeRequest("/clients", "POST", data),
 update: async (data)=> exeRequest("/clients", "PUT", data)
}